import { CircularProgress, ImageList, ImageListItem, ImageListItemBar, useMediaQuery } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { getEnvironmentConfig, useMinio } from "@tt/ttms-react-core";
import axios from "axios";
import { orderBy } from "lodash";
import React, { useEffect } from "react";
import { useGetList, useNotify } from "react-admin";
import { Link } from "react-router-dom";
import AuthorizedCheck from "../../components/Authorized/AuthorizedCheck";
import * as config from "../../config";
import defaultImage from "../video/default.png";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    flexWrap: "nowrap",
    transform: "translateZ(0)",
    paddingLeft: "10px",
    justifyContent: "left",
    width: "100%",
  },
  title: {
    color: theme.palette.primary.light,
  },
  titleBar: {
    background: "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)",
  },
  videoTitle: {
    float: "left",
    width: "100%",
    paddingLeft: "10px",
  },
  videoThumbnail: {
    maxWidth: "100%",
  },
}));

function useColumns() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.between("xs", "md"));
  const largerThanLg = useMediaQuery(theme.breakpoints.up("lg"));

  let columns = 2;
  if (isSmallScreen) {
    columns = 2;
  }
  if (largerThanLg) {
    columns = 6;
  }
  return columns;
}

function VideoGrid({ items }) {
  const classes = useStyles();
  const columns = useColumns();
  const minio = useMinio();

  return (
    <ImageList className={classes.gridList} cols={columns}>
      {items != null &&
        Object.values(items).map((video: any) => {
          //const imageUrl = video.thumbnailPath !== null ? minio.convertUrl(video.thumbnailPath) : `https://unsplash.it/400/300?${video.id}`;
          const imageUrl = video.thumbnailPath !== null ? minio.convertUrl(video.thumbnailPath) : defaultImage;

          return (
            <ImageListItem key={video.id} component={Link} to={"/videos/" + video.id + "/show"}>
              <img src={imageUrl} alt={video.title} className={classes.videoThumbnail} />
              <ImageListItemBar
                title={video.title}
                //subtitle={<span>Kategori: {video.author}</span>}
              />
            </ImageListItem>
          );
        })}
    </ImageList>
  );
}

export function Dashboard() {
  const classes = useStyles();
  const [popularVideos, setPopularVideos] = React.useState<[] | any>();
  const notify = useNotify();

  // Recommended Videos
  // 1. createdDate desc
  // 2. Deleted false - API tarafından otomatik olarak gelir.
  // 3. status = 3
  // 4. isSuggested = true
  const {
    loaded: loadedRV,
    loading: loadingRV,
    data: RV,
  } = useGetList("videos", { page: 1, perPage: 10 }, { field: "id", order: "DESC" }, { status__eq: "3", isSuggested__eq: "true" });
  const recommendedVideos = orderBy(RV, ["id"], ["desc"]);

  // New Videos
  // 1. createdDate desc
  // 2. Deleted false - API tarafından otomatik olarak gelir.
  // 3. status = 3
  const {
    loaded: loadedNV,
    loading: loadingNV,
    data: NV,
  } = useGetList("videos", { page: 1, perPage: 10 }, { field: "id", order: "DESC" }, { status__eq: "3" });
  const NewVideos = orderBy(NV, ["id"], ["desc"]);

  // Popular Videos
  // const dp = useAppDataProvider();
  // React.useEffect(() => {
  //   dp.getPopularVideos().then((res) => {
  //     console.log("Promise response :", res);
  //     setPopularVideos(res.data);
  //   });
  // }, [dp]);

  useEffect(() => {
    const envConfig = getEnvironmentConfig(config);
    let token = `Bearer ${localStorage.getItem("token")}`;

    axios
      .get(envConfig.apiBaseUrl + `/videos/getpopularvideos`, {
        headers: {
          authorization: token,
        },
      })
      .then((res) => {
        console.log("popular videos by axios: ", res);
        setPopularVideos(res?.data);
      })
      .catch((err) => {
        console.log("err: ", err);
        notify(err?.response?.data?.message, "error");
      });
  }, []);

  return (
    <AuthorizedCheck isAdmin={false}>
      <div className={classes.root}>
        <h3 className={classes.videoTitle}>Recommended Videos</h3>
        {loadingRV && <CircularProgress />}
        {loadedRV && <VideoGrid items={recommendedVideos} />}

        <h3 className={classes.videoTitle}>New Videos</h3>
        {loadingNV && <CircularProgress />}
        {loadedNV && <VideoGrid items={NewVideos} />}

        <h3 className={classes.videoTitle}>Popular Videos</h3>
        <VideoGrid items={popularVideos} />
      </div>
    </AuthorizedCheck>
  );
}
